import React, { useEffect } from 'react';
import styles from './styles';
import PropTypes from 'prop-types';
import Link from 'next/link';
import Image from 'next/image';

const ContactWithButton = ({ block }) => {
  if (!block) return '';
  const { primary, items } = block;
  const header = primary?.header;
  const description = primary?.description;

  const openChat = () => {
    window.FrontChat('show');
  };

  return (
    <>
      <div className="main-container">
        <h3 className="main-header">AFTERSHOCK SUPPORT</h3>
        <div className="header-container">
          <h3 className="header">{header}</h3>
          <p className="description">{description}</p>
        </div>

        <div className="btn-container">
          <Link href="/faq-hub">
            <a className="btn btn-link">
              <Image
                draggable="false"
                src={
                  'https://images.prismic.io/aftershockpc/698f8a9c-2042-47c0-9557-e30ededc19df_SALE_ENQUIRY_ICON.png?auto=compress,format'
                }
                width={30}
                height={30}
                alt="FAQ - icon"
                className="btn-icon"
              />
              <span>FAQ</span>
            </a>
          </Link>
          {items.map((item, i) => {
            if (item.contact_button == 'Whatsapp') {
              return (
                <buton
                  key={i}
                  className="btn whatsapp"
                  onClick={() =>
                    (window.location.href =
                      'whatsapp://send?text=Hello!&phone=+61483945106')
                  }
                >
                  <img
                    draggable="false"
                    src={
                      'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/whatsapp.png?v=1713873736'
                    }
                    alt="whatsapp-icon"
                    className="btn-icon"
                  />
                  Whatsapp
                </buton>
              );
            } else if (item.contact_button == 'LiveChat') {
              return (
                <buton key={i} className="btn livechat" onClick={openChat}>
                  <img
                    draggable="false"
                    src={
                      'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/livechat.png?v=1713873774'
                    }
                    alt="whatsapp-icon"
                    className="btn-icon"
                  />
                  <span>Live Chat</span>
                </buton>
              );
            }
          })}
          <Link href="/knowledge-hub">
            <a className="btn btn-link">
              <Image
                draggable="false"
                src={
                  'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/Vector_3.png?v=1715066809'
                }
                width={26}
                height={22}
                alt="knowledge-hub"
                className="btn-icon"
              />
              <span>Knowledge hub</span>
            </a>
          </Link>
        </div>
        <div className="btn-container-mobile">
          <Link href="/faq-hub">
            <div className="btn-link-wrapper">
              <a className="btn-mobile btn-link">
                <Image
                  draggable="false"
                  src={
                    'https://images.prismic.io/aftershockpc/698f8a9c-2042-47c0-9557-e30ededc19df_SALE_ENQUIRY_ICON.png?auto=compress,format'
                  }
                  width={40}
                  height={40}
                  alt="FAQ - icon"
                  className="btn-icon"
                />
              </a>
              <span>FAQ</span>
            </div>
          </Link>
          {items.map((item, i) => {
            if (item.contact_button == 'Whatsapp') {
              return (
                <div>
                  <buton
                    className="btn-mobile whatsapp"
                    onClick={() =>
                      (window.location.href =
                        'whatsapp://send?text=Hello!&phone=+61483945106')
                    }
                  >
                    <img
                      draggable="false"
                      src={
                        'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/whatsapp.png?v=1713873736'
                      }
                      alt="whatsapp-icon"
                      className="btn-icon-mobile"
                    />
                  </buton>
                  <span className="btn-mobile-label">Whatsapp</span>
                </div>
              );
            } else if (item.contact_button == 'LiveChat') {
              return (
                <div className="btn-link-wrapper">
                  <buton className="btn-mobile livechat" onClick={openChat}>
                    <img
                      draggable="false"
                      src={
                        'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/livechat.png?v=1713873774'
                      }
                      alt="whatsapp-icon"
                      className="btn-icon-mobile"
                    />
                  </buton>
                  <span className="btn-mobile-label">Live Chat</span>
                </div>
              );
            }
          })}
          <Link href="/knowledge-hub">
            <div className="btn-link-wrapper">
              <a className="btn-mobile btn-link">
                <Image
                  draggable="false"
                  src={
                    'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/Vector_3.png?v=1715066809'
                  }
                  width={36}
                  height={30}
                  alt="knowledge-hub"
                  className="btn-icon"
                />
              </a>
              <span className="btn-mobile-label">Knowledge hub</span>
            </div>
          </Link>
        </div>
      </div>

      <style jsx>{styles}</style>
    </>
  );
};
ContactWithButton.propTypes = {
  block: PropTypes.shape({
    primary: PropTypes.shape({
      header: PropTypes.string,
      imageUrl: PropTypes.object,
    }),
  }),
};

ContactWithButton.defaultProps = {
  block: null,
};

export default ContactWithButton;
